/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Luci_Shopping_Api_Models_BillingAddress } from './Luci_Shopping_Api_Models_BillingAddress';
import type { Luci_Shopping_Api_Models_ShippingAddress } from './Luci_Shopping_Api_Models_ShippingAddress';
export type Luci_Shopping_Api_Requests_PrepareCartForCheckoutRequest = {
  billingAddress?: Luci_Shopping_Api_Models_BillingAddress;
  deliveryMethod?: Luci_Shopping_Api_Requests_PrepareCartForCheckoutRequest.deliveryMethod;
  shippingAddress?: Luci_Shopping_Api_Models_ShippingAddress;
  /**
   * Recaptcha challenge token for verifying the request is authentic.
   */
  challengeToken: string;
};
export namespace Luci_Shopping_Api_Requests_PrepareCartForCheckoutRequest {
  export enum deliveryMethod {
    POINT_OF_SALE = 'PointOfSale',
    SHIPPING = 'Shipping',
    PICKUP = 'Pickup',
  }
}

